import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('melontv_later')
  },
  async add(melontvlaterId) {
    return await request.get('add_later/' + melontvlaterId)
  }
}
